module.exports = __webpack_public_path__ + "img/TZS09705.2af9c4b9.jpeg";